import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class OverlayViewModel extends ControlViewModel{

    /**
     * Specifies if the Tooltip will be hidden when mouse leaves the target element. If set to false a close button will be shown within Tooltip. If set to false, showAfter is specified and the showOn is set to "mouseenter" the Tooltip will be displayed after the given timeout even if the element is no longer hovered.
     */
    public isAutoHide: boolean;

    /**
     * The position relative to the target element, at which the Tooltip will be shown. Predefined values are "bottom", "top", "left", "right", "center".
     */
    public position: string;

    /**
     * Gibt an, ob das Overlay bei Klick auf das Element angezeigt wird
     */
    public isShownOnClick: boolean;

    /**
     * Gibt an, ob das Overlay bei Hover über das Element angezeigt wird
     */
    public isShownOnHover: boolean;

    /**
     * Gibt an, ob das Overlay bei Klick auf dessen Inhalt geschlossen wird
     */
    public isClosedOnClick: boolean;

    /**
     * Specify the delay in milliseconds before the Tooltip is shown. This option is ignored if showOn is set to "click" or "focus".
     */
    public showAfter: number;

    /**
     * The text or a function which result will be shown within the Tooltip. By default the Tooltip will display the target element title attribute content.
     */
    public content: Function;

    /**
     * Specifies a selector for elements, within the container, for which the Tooltip will be displayed.
     */
    public filter: string;

    /**
     * Specifies whether the tooltip callout arrow will be displayed.
     */
    public showCallout: boolean;

    public dontCloseOnClick: boolean;

    /**
     * Das ViewModel für den Overlay
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.isAutoHide = this.paramOrDefault(params.isAutoHide, false);
        this.position = this.paramOrDefault(params.position, 'left');
        this.isShownOnClick = this.paramOrDefault(params.isShownOnClick, false);
        this.isShownOnHover = this.paramOrDefault(params.isShownOnHover, false);
        this.isClosedOnClick = this.paramOrDefault(params.isClosedOnClick, false);
        this.showAfter = this.paramOrDefault(params.showAfter, 100);
        this.content = this.paramOrDefault(params.content, '');
        this.filter = this.paramOrDefault(params.filter, null);
        this.showCallout = this.paramOrDefault(params.showCallout, true);
        this.dontCloseOnClick = false;
    }
}

ComponentManager.setViewModel('OverlayViewModel', OverlayViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');